import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { Store, select } from '@ngrx/store';
import {
  getBluePrismCurrentConnector,
  getIsLoadingDetail
} from '../store/selectors/rpa-blueprism-conn.selector';
import { UpdateBluePrismConn, TestBluePrismConn } from '../store/actions/rpa-blueprism-conn.actions';
import { BluePrismConfigurationComponent } from '../blue-prism-configuration/blue-prism-configuration.component';
import { RpaConnectorDetail } from '../../../rpa-bots/core/rpa-details-details.types';
import { RpaBotsService } from '../../core/rpa-bots.service';
import { IAppState } from '../../../IAppState';
import { IRPAWrapperDetails, IRpaConnectionBluePrism } from '../../../rpa-bots/core/IRpaBots';

@Component({
  selector: 'blue-prism-detail-wrapper',
  templateUrl: 'blue-prism-detail-wrapper.component.html',
  styleUrls: ['blue-prism-detail-wrapper.component.scss']
})
export class BluePrismDetailWrapperComponent implements IRPAWrapperDetails {
  public bluePrismConnection$: Observable<IRpaConnectionBluePrism>;
  public isLoading$: Observable<boolean>;
  @ViewChild('bluePrismConfiguration', { static: false})
  private _bluePrismConfigurationComponent: BluePrismConfigurationComponent;
  @Input() pendingChangesFunction: Function;
  constructor(private _store: Store<IAppState>,
    private _rpaBotsService: RpaBotsService) {
    this.bluePrismConnection$ = this._store.pipe(
      select(getBluePrismCurrentConnector)
    );
    this.isLoading$ = this._store.pipe(select(getIsLoadingDetail));
  }

  onSave(bot: IRpaConnectionBluePrism) {
    this._store.dispatch(new UpdateBluePrismConn(bot));
  }

  onTestConnection(bot: IRpaConnectionBluePrism) {
    this._store.dispatch(new TestBluePrismConn(bot));
  }

  get isConnectorValid(): boolean {
    return this._bluePrismConfigurationComponent ? this._bluePrismConfigurationComponent.isValid() : false;
  }

  get hasPendingChanges(): boolean {
    return this._bluePrismConfigurationComponent ? this._bluePrismConfigurationComponent.hasChanges : false;
  }

  get modifiedConnector(): RpaConnectorDetail {
    return this._bluePrismConfigurationComponent ? this._bluePrismConfigurationComponent.botDetail : null;
  }
}
